import React, { useState } from 'react';
import {
  CardRow,
  LoadingMessage,
  ErrorMessage,
  EmptyMessage,
  TimeAgo,
  getFileResourceURL,
} from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

const attachmentFields = ['Attachment1', 'Attachment2', 'Attachment3'];

export const ActivityLogs = ({
  type,
  id,
  loading,
  logs,
  error,
  fetch,
  addComment,
}) => {
  const [open, setOpen] = useState(!!logs || !!loading);
  const commentButton =
    typeof addComment === 'function' ? (
      <>
        <span className="mx-2">{'\u00B7'}</span>
        <button className="btn btn-text" onClick={addComment}>
          <I18n>Add Comment</I18n>
        </button>
      </>
    ) : null;
  return (
    <CardRow>
      {!open ? (
        <>
          <button
            className="btn btn-text"
            onClick={() => {
              fetch({ id, type });
              setOpen(true);
            }}
          >
            <I18n>Show Activity Logs</I18n>
          </button>
          {commentButton}
        </>
      ) : (
        <>
          <div className="activity__logs">
            <div className="activity__logs--header">
              <strong>
                <I18n>Activity Logs</I18n>
              </strong>
              {commentButton}
              <button
                className="btn btn-text-danger ml-auto"
                onClick={() => setOpen(false)}
              >
                <span className="fa fa-fw fa-times" />
              </button>
            </div>
            {error ? (
              <div className="activity__logs--item">
                <ErrorMessage heading={false} message={error.message} />
              </div>
            ) : loading ? (
              <div className="activity__logs--item">
                <LoadingMessage />
              </div>
            ) : logs && logs.length > 0 ? (
              logs.map((log, i) => (
                <div key={`log-${i}`} className="activity__logs--item">
                  {log['Summary'] && (
                    <div>
                      <strong>{log['Summary']}</strong>
                    </div>
                  )}
                  {(log['SubmitDate'] || log['Submitter']) && (
                    <div className="text-muted">
                      <I18n>Created</I18n>{' '}
                      {log['SubmitDate'] && (
                        <strong>
                          <TimeAgo timestamp={log['SubmitDate']} />{' '}
                        </strong>
                      )}
                      {log['Submitter'] && (
                        <>
                          <I18n>by</I18n> <strong>{log['Submitter']}</strong>
                        </>
                      )}
                    </div>
                  )}
                  {log['Notes'] && <div className="mt-2">{log['Notes']}</div>}
                  {attachmentFields.some(a => !!log[a]) && (
                    <div className="attachments my-2">
                      {attachmentFields.filter(a => !!log[a]).map(a => (
                        <a
                          href={getFileResourceURL(
                            'ars',
                            `${log['MetaFormName']}/${log['Id']}/${
                              log[`Meta${a}FieldId`]
                            }/${log[a]}`,
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="fa fa-paperclip mr-2" />
                          <I18n>{log[a]}</I18n>
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="activity__logs--item">
                <EmptyMessage title="No activity logs found." />
              </div>
            )}
          </div>
        </>
      )}
    </CardRow>
  );
};
